import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Select,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { connect } from "react-redux";
import { getALLStudent } from "../../../configs/redux/action";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup
  .object({
    student_id: yup.number().positive().integer().required(),
    register_amount: yup.number().positive().integer().required(),
    installment_amount: yup.number().positive().integer().required(),
    spp_total: yup.number().positive().integer().required(),
  })
  .required();

const NewStudentPayment = ({
  isOpen,
  handleCloseModal,
  selectedRow,
  handleSaveChanges,
  getALLStudent,
  dataStudent,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    getALLStudent();
  }, [getALLStudent]);

  useEffect(() => {
    if (selectedRow) {
      setValue("student_id", selectedRow.student_id);
    } else {
      setValue("student_id", "");
    }
  }, [selectedRow, setValue]);

  const onSubmit = (data) => {
    let id = selectedRow?.student_id || 0;
    handleSaveChanges(data);
    // register_amount, installment_amount, spp_total
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCloseModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Input Pembayaran Siswa Baru</ModalHeader>
        <ModalCloseButton />
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <FormControl mb={4}>
              <FormLabel htmlFor="student_id">Student Name</FormLabel>
              <Select
                name="student_id"
                id="student_id"
                {...register("student_id")}
              >
                <option value="">Select Student</option>
                {dataStudent.map((student) => (
                  <option key={student.id} value={student.id}>
                    {student.nis} || {student.name}
                  </option>
                ))}
              </Select>
              {errors.student_id && (
                <Text fontSize="xs" color="tomato">
                  {errors.student_id.message}
                </Text>
              )}
            </FormControl>
            <FormControl mb={4}>
              <FormLabel htmlFor="register_amount">
                Biaya Daftar Ulang
              </FormLabel>
              <Input
                type="number"
                name="register_amount"
                id="register_amount"
                {...register("register_amount")}
              />
              {errors.register_amount && (
                <Text fontSize="xs" color="tomato">
                  {errors.register_amount.message}
                </Text>
              )}
            </FormControl>
            <FormControl mb={4}>
              <FormLabel htmlFor="due_date">
                Jumlah Cicilan Daftar Ulang
              </FormLabel>
              <Input
                type="number "
                name="installment_amount"
                id="installment_amount"
                {...register("installment_amount")}
              />
              {errors.installment_amount && (
                <Text fontSize="xs" color="tomato">
                  {errors.installment_amount.message}
                </Text>
              )}
            </FormControl>
            <FormControl mb={4}>
              <FormLabel htmlFor="spp_total">Total SPP 11 Bulan</FormLabel>
              <Input
                type="number"
                name="spp_total"
                id="spp_total"
                {...register("spp_total")}
              />
              {errors.spp_total && (
                <Text fontSize="xs" color="tomato">
                  {errors.spp_total.message}
                </Text>
              )}
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} type="submit">
              Save Changes
            </Button>
            <Button variant="ghost" onClick={handleCloseModal}>
              Cancel
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

const reduxState = (state) => ({
  dataStudent: state.getData.dataStudent.data,
  LoadingData2: state.getData.dataStudent.loading,
});

const reduxDispatch = (dispatch) => {
  return {
    getALLStudent: () => dispatch(getALLStudent()),
  };
};

export default connect(reduxState, reduxDispatch)(NewStudentPayment);
